export const FRONTEND_ENTITY_TABLE_UI_PREFS_KEY = 'entityTable';
